var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPuertas({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 114.242,
    height: 82.423,
    viewBox: "0 0 114.242 82.423",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1924",
    "data-name": "Grupo 1924",
    transform: "translate(0.25 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_027-door-2",
    "data-name": "027-door-2",
    transform: "translate(0 0.268)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_192",
    "data-name": "Grupo 192",
    transform: "translate(4.727)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_191",
    "data-name": "Grupo 191"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_308",
    "data-name": "Trazado 308",
    d: "M149.885,0H103.757A1.356,1.356,0,0,0,102.4,1.357V80.048a1.356,1.356,0,0,0,1.357,1.357h46.129a1.356,1.356,0,0,0,1.357-1.357V1.357A1.356,1.356,0,0,0,149.885,0Zm-1.357,78.691H105.114V2.714h43.415V78.691Z",
    transform: "translate(-102.4)",
    fill: "#003082",
    stroke: "#003082",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_194",
    "data-name": "Grupo 194",
    transform: "translate(10.154 5.427)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_193",
    "data-name": "Grupo 193"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_309",
    "data-name": "Trazado 309",
    d: "M173.165,34.133H137.891a1.356,1.356,0,0,0-1.357,1.357v73.264a1.356,1.356,0,0,0,1.357,1.357h35.275a1.356,1.356,0,0,0,1.357-1.357V35.49A1.356,1.356,0,0,0,173.165,34.133ZM171.809,107.4H139.247V36.847h32.561V107.4Z",
    transform: "translate(-136.534 -34.133)",
    fill: "#003082"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_196",
    "data-name": "Grupo 196",
    transform: "translate(15.581 10.854)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_195",
    "data-name": "Grupo 195"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_310",
    "data-name": "Trazado 310",
    d: "M184.234,68.267a13.583,13.583,0,0,0-13.567,13.567v1.357a1.356,1.356,0,0,0,1.357,1.357h24.421a1.356,1.356,0,0,0,1.357-1.357V81.834A13.583,13.583,0,0,0,184.234,68.267ZM173.38,81.834a10.854,10.854,0,1,1,21.708,0Z",
    transform: "translate(-170.667 -68.267)",
    fill: "#86888b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_198",
    "data-name": "Grupo 198",
    transform: "translate(15.581 29.848)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_197",
    "data-name": "Grupo 197"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_311",
    "data-name": "Trazado 311",
    d: "M181.521,187.733h-9.5a1.356,1.356,0,0,0-1.357,1.357v18.994a1.356,1.356,0,0,0,1.357,1.357h9.5a1.356,1.356,0,0,0,1.357-1.357V189.09A1.356,1.356,0,0,0,181.521,187.733Zm-1.357,18.994H173.38V190.447h6.784Z",
    transform: "translate(-170.667 -187.733)",
    fill: "#86888b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_200",
    "data-name": "Grupo 200",
    transform: "translate(30.505 29.848)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_199",
    "data-name": "Grupo 199"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_312",
    "data-name": "Trazado 312",
    d: "M275.388,187.733h-9.5a1.356,1.356,0,0,0-1.357,1.357v18.994a1.356,1.356,0,0,0,1.357,1.357h9.5a1.356,1.356,0,0,0,1.357-1.357V189.09A1.356,1.356,0,0,0,275.388,187.733Zm-1.357,18.994h-6.784V190.447h6.784Z",
    transform: "translate(-264.534 -187.733)",
    fill: "#86888b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_202",
    "data-name": "Grupo 202",
    transform: "translate(15.581 54.27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_201",
    "data-name": "Grupo 201"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_313",
    "data-name": "Trazado 313",
    d: "M181.521,341.333h-9.5a1.356,1.356,0,0,0-1.357,1.357v18.994a1.356,1.356,0,0,0,1.357,1.357h9.5a1.356,1.356,0,0,0,1.357-1.357V342.69A1.356,1.356,0,0,0,181.521,341.333Zm-1.357,18.994H173.38V344.047h6.784Z",
    transform: "translate(-170.667 -341.333)",
    fill: "#86888b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_204",
    "data-name": "Grupo 204",
    transform: "translate(30.505 54.27)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_203",
    "data-name": "Grupo 203"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_314",
    "data-name": "Trazado 314",
    d: "M275.388,341.333h-9.5a1.356,1.356,0,0,0-1.357,1.357v18.994a1.356,1.356,0,0,0,1.357,1.357h9.5a1.356,1.356,0,0,0,1.357-1.357V342.69A1.356,1.356,0,0,0,275.388,341.333Zm-1.357,18.994h-6.784V344.047h6.784Z",
    transform: "translate(-264.534 -341.333)",
    fill: "#86888b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_206",
    "data-name": "Grupo 206",
    transform: "translate(27.791 10.854)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_205",
    "data-name": "Grupo 205"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_315",
    "data-name": "Trazado 315",
    d: "M248.824,68.267a1.356,1.356,0,0,0-1.357,1.357V83.191a1.357,1.357,0,1,0,2.713,0V69.624A1.356,1.356,0,0,0,248.824,68.267Z",
    transform: "translate(-247.467 -68.267)",
    fill: "#86888b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_208",
    "data-name": "Grupo 208",
    transform: "translate(27.791 15.135)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_207",
    "data-name": "Grupo 207"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_316",
    "data-name": "Trazado 316",
    d: "M259.066,95.594a1.355,1.355,0,0,0-1.918,0l-9.285,9.286a1.356,1.356,0,1,0,1.918,1.918l9.285-9.285A1.355,1.355,0,0,0,259.066,95.594Z",
    transform: "translate(-247.464 -95.196)",
    fill: "#86888b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_210",
    "data-name": "Grupo 210",
    transform: "translate(18.505 15.134)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_209",
    "data-name": "Grupo 209"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_317",
    "data-name": "Trazado 317",
    d: "M200.664,104.872l-9.285-9.287A1.357,1.357,0,0,0,189.46,97.5l9.285,9.287a1.357,1.357,0,0,0,1.918-1.919Z",
    transform: "translate(-189.062 -95.187)",
    fill: "#86888b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_212",
    "data-name": "Grupo 212",
    transform: "translate(0 78.692)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_211",
    "data-name": "Grupo 211"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_318",
    "data-name": "Trazado 318",
    d: "M9.5,494.933H1.357a1.357,1.357,0,0,0,0,2.714H9.5a1.357,1.357,0,0,0,0-2.714Z",
    transform: "translate(0 -494.933)",
    fill: "#003082",
    stroke: "#003082",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_214",
    "data-name": "Grupo 214",
    transform: "translate(46.523 78.692)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_213",
    "data-name": "Grupo 213"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_319",
    "data-name": "Trazado 319",
    d: "M434.828,494.933H395.787c-1.8,0-3.253.607-3.253,1.357s1.458,1.357,3.253,1.357h39.041c1.8,0,3.253-.606,3.253-1.357S436.624,494.933,434.828,494.933Z",
    transform: "translate(-392.534 -494.933)",
    fill: "#003082",
    stroke: "#003082",
    strokeWidth: 0.5
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_389",
    "data-name": "Trazado 389",
    d: "M0,0H9.609V10.677H0Z",
    transform: "translate(100.41 38.84)",
    fill: "#86888b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_024-glass-1",
    "data-name": "024-glass-1",
    transform: "translate(62.718)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_216",
    "data-name": "Grupo 216",
    transform: "translate(24.513 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_215",
    "data-name": "Grupo 215"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_320",
    "data-name": "Trazado 320",
    d: "M247.677.3a1,1,0,0,0-1.7.7,1,1,0,1,0,1.7-.7Z",
    transform: "translate(-245.976 -0.006)",
    fill: "#003082",
    stroke: "#003082",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_218",
    "data-name": "Grupo 218",
    transform: "translate(17.854 13.413)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_217",
    "data-name": "Grupo 217"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_321",
    "data-name": "Trazado 321",
    d: "M180.859,134.885a1,1,0,1,0,.292.7A1.006,1.006,0,0,0,180.859,134.885Z",
    transform: "translate(-179.158 -134.593)",
    fill: "#003082",
    stroke: "#003082",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_220",
    "data-name": "Grupo 220",
    transform: "translate(6.219 16.166)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_219",
    "data-name": "Grupo 219"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_322",
    "data-name": "Trazado 322",
    d: "M72.99,162.512a1,1,0,0,0-1.409,0L62.7,171.394a1,1,0,1,0,1.409,1.409l8.882-8.882A1,1,0,0,0,72.99,162.512Z",
    transform: "translate(-62.407 -162.22)",
    fill: "#003082",
    stroke: "#003082",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_222",
    "data-name": "Grupo 222",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_221",
    "data-name": "Grupo 221"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_323",
    "data-name": "Trazado 323",
    d: "M47.038,47.037h2.99a1,1,0,0,0,1-1V6.583c0-.009,0-.018,0-.027V1a1,1,0,0,0-1-1H30.592a1,1,0,0,0,0,1.993H49.03V5.587H1.993V2h18.8a1,1,0,0,0,0-1.993H1A1,1,0,0,0,0,1V46.04a1,1,0,0,0,1,1H34.681v1.825c0,.059,0,.117.008.174H14.41a1,1,0,0,0,0,1.993H50.027a1,1,0,0,0,0-1.993h-3c0-.058.008-.116.008-.174ZM24.516,45.044H1.993v-2.5L20.559,23.977a1,1,0,0,0-1.409-1.409L1.993,39.725V7.58H24.516V45.044Zm20.529,3.818a.175.175,0,0,1-.174.174H36.848a.175.175,0,0,1-.174-.174V39.071h8.371ZM39.054,37.078h-.892a24.7,24.7,0,0,0-1.1-3.781A6.392,6.392,0,0,1,39.054,37.078Zm-1.179-9.664a7.382,7.382,0,0,1,3.072,5.858,16.275,16.275,0,0,0-.374,1.775,8.513,8.513,0,0,0-1-1.893A27.216,27.216,0,0,0,37.875,27.414Zm4.741,1.861c-.122.21-.239.423-.352.638a9.4,9.4,0,0,0-.488-1.026c0-.023.005-.045.006-.068a5.377,5.377,0,0,1,1.207-3.039,14.731,14.731,0,0,0-.387,3.338A1.011,1.011,0,0,0,42.616,29.275Zm2.224.2a32.476,32.476,0,0,0-1.287,7.6H42.387A14.349,14.349,0,0,1,44.84,29.478Zm1.2,7.6h-.493a28.352,28.352,0,0,1,2.993-11.456c.014-.024.029-.054.041-.079a1,1,0,0,0-1.489-1.229,16.183,16.183,0,0,0-2.153,1.881,12.694,12.694,0,0,1,.819-2.385A1,1,0,0,0,44.407,22.5l-1.07.536a6.334,6.334,0,0,0-3.149,3.736,9.258,9.258,0,0,0-2.552-1.809l-1.558-.745a1,1,0,0,0-1.3,1.38l.1.189a25.22,25.22,0,0,1,2.086,5c-.129-.072-.259-.141-.393-.2l-1.306-.624a1,1,0,0,0-1.3,1.38l.087.158a21.383,21.383,0,0,1,2.074,5.583h-.446a1,1,0,0,0-1,1v6.97H26.509V7.58H49.031V45.044H47.038v-6.97A1,1,0,0,0,46.041,37.078Z",
    transform: "translate(0 -0.006)",
    fill: "#003082",
    stroke: "#003082",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_224",
    "data-name": "Grupo 224",
    transform: "translate(8.784 49.03)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_223",
    "data-name": "Grupo 223"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_324",
    "data-name": "Trazado 324",
    d: "M89.842,492.285a1,1,0,1,0,.292.7A1.006,1.006,0,0,0,89.842,492.285Z",
    transform: "translate(-88.141 -491.993)",
    fill: "#003082",
    stroke: "#003082",
    strokeWidth: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuertas);
export default __webpack_public_path__ + "static/media/puertas.4395167f8fc4c4200bc35143471d66ff.svg";
export { ForwardRef as ReactComponent };